import { useState } from "react";
import MyTable from "../../Components/MyTable";
import Mytitle from "../../Components/Mytitle";
import ModalForm from "../../Components/ModalForm";
import MyInput from "../../Components/Myinput";
import API from "../../Api/axiosConfig";
import MyButton from "../../Components/MyButton";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEye, faPen, faTrash } from "@fortawesome/free-solid-svg-icons";
import Can from "../../Components/Can";

function Customers() {
  const [showModal, setShowModal] = useState(false);
  const [formData, setFormData] = useState({
    name: "",
    phone: null,
    opening_balance: "",
  });
  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);
  const [refreshKey, setRefreshKey] = useState(0);
  const [editId, setEditId] = useState(null);

  const [deleteId, setDeleteId] = useState(null);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [deleting, setDeleting] = useState(false);

  const [showDetailsModal, setShowDetailsModal] = useState(false);
  const [selectedCustomer, setSelectedCustomer] = useState(null);

  const handleAdd = () => {
    setFormData({
      name: "",
      phone: null,
      opening_balance: "",
    });
    setEditId(null);
    setErrors({});
    setShowModal(true);
  };

  const handleEdit = (record) => {
    setFormData({ ...record });
    setEditId(record.uuid);
    setErrors({});
    setShowModal(true);
  };

  const handleDeleteClick = (id) => {
    setDeleteId(id);
    setShowDeleteModal(true);
  };

  const confirmDelete = async () => {
    setDeleting(true);
    try {
      await API.delete(`/customers/${deleteId}`);
      console.log("تم حذف العميل بنجاح");
      setRefreshKey((prev) => prev + 1);
      setShowDeleteModal(false);
      setDeleteId(null);
    } catch (err) {
      console.error(err);
    } finally {
      setDeleting(false);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setErrors({});

    try {
      if (editId) {
        await API.put(`/customers/${editId}`, formData);
        console.log("تم تعديل العميل بنجاح");
      } else {
        await API.post("/customers", formData);
        console.log("تم إضافة العميل بنجاح");
      }
      setShowModal(false);
      setRefreshKey((prev) => prev + 1);
    } catch (err) {
      if (err.response?.data?.errors) {
        setErrors(err.response.data.errors);
      }
    } finally {
      setLoading(false);
    }
  };

  const handleShowDetails = (customer) => {
    setSelectedCustomer(customer);
    setShowDetailsModal(true);
  };

  const columns = [
    { header: "الاسم", accessor: "name" },
    { header: "الهاتف", accessor: "phone" },
    { header: "الرصيد الحالي", accessor: "last_balance.total_value" },
    {
      header: "الإجراءات",
      accessor: (row) => (
        <>
          {row.can_deleted === 1 && (
            <>
              <Can permission="customer_show">
                <button
                  className="btn btn-sm btn-primary mx-1 no-style"
                  onClick={() => handleShowDetails(row)}>
                  <FontAwesomeIcon icon={faEye} />
                </button>
              </Can>

              <Can permission="customer_update">
                <button
                  className="btn btn-sm btn-primary mx-1 no-style"
                  onClick={() => handleEdit(row)}>
                  <FontAwesomeIcon icon={faPen} />
                </button>
              </Can>
              <Can permission="customer_delete">
                <button
                  className="btn btn-sm btn-danger no-style"
                  onClick={() => handleDeleteClick(row.uuid)}>
                  <FontAwesomeIcon icon={faTrash} />
                </button>
              </Can>
            </>
          )}
        </>
      ),
      hideOnPrint: true,
    },
  ];

  return (
    <div className="container mt-5">
      <Mytitle title="العملاء" />

      {/* <Can permission="employee_create">
        <MyButton
          text="إضافة عميل"
          variant="success"
          type="button"
          className="mb-3"
          onClick={handleAdd}
        />
      </Can> */}

      <ModalForm
        show={showModal}
        onClose={() => setShowModal(false)}
        title={editId ? "تعديل العميل" : "إضافة عميل"}
        onSubmit={handleSubmit}
        loading={loading}
        mode="form">
        <MyInput
          label="الاسم"
          value={formData.name}
          onChange={(e) => setFormData({ ...formData, name: e.target.value })}
          error={errors.name?.[0]}
        />
        <MyInput
          label="الهاتف"
          type="number"
          value={formData.phone}
          onChange={(e) => setFormData({ ...formData, phone: e.target.value })}
          error={errors.phone?.[0]}
        />
        <MyInput
          label="الرصيد الافتتاحي"
          type="number"
          value={formData.opening_balance}
          onChange={(e) =>
            setFormData({
              ...formData,
              opening_balance: e.target.value,
            })
          }
          error={errors.opening_balance?.[0]}
        />
      </ModalForm>

      <ModalForm
        show={showDeleteModal}
        onClose={() => setShowDeleteModal(false)}
        title="تأكيد الحذف"
        onSubmit={confirmDelete}
        loading={deleting}
        mode="confirm"
        confirmText="حذف"
        cancelText="إلغاء">
        هل أنت متأكد أنك تريد حذف هذا العميل؟
      </ModalForm>

      <ModalForm
        show={showDetailsModal}
        onClose={() => setShowDetailsModal(false)}
        title={`${selectedCustomer?.name || ""}`}
        mode="view">
        {selectedCustomer?.balances?.length ? (
          <table className="table table-bordered">
            <thead>
              <tr>
                <th>التاريخ</th>
                <th>النوع</th>
                <th>القيمة</th>
                <th>الرصيد</th>
              </tr>
            </thead>
            <tbody>
              {selectedCustomer.balances.map((b) => (
                <tr key={b.id}>
                  <td>{b.date}</td>
                  <td>
                    {b.type === "opening_balance"
                      ? "الرصيد الأفتتاحي"
                      : "receive_money_invoice"
                      ? "فاتورة"
                      : ""}
                  </td>
                  <td>{b.value}</td>
                  <td>{b.total_value}</td>
                </tr>
              ))}
            </tbody>
          </table>
        ) : (
          <p>لا توجد مدفوعات مسجلة لهذا العميل.</p>
        )}
      </ModalForm>

      <MyTable
        resource="customers"
        columns={columns}
        refreshKey={refreshKey}
        title={"العملاء"}
        button={{
          text: editId ? "تعديل العميل" : "إضافة عميل",
          onClick: handleAdd,
          variant: "success",
          permission: "employee_create",
        }}
      />

      <div
        style={{
          position: "relative",
          bottom: "20px", // مسافة بسيطة من تحت
          left: "50%",
          transform: "translateX(-50%)", // يخلّي العنصر في وسط الشاشة بالظبط
          zIndex: 1000,
          marginTop: "40px",
          width: "fit-content",
        }}>
        <div
          className="text-center"
          style={{
            borderRadius: "15px",
            padding: "12px 35px",
            boxShadow: "0 2px 10px rgba(0,0,0,0.1)",
            minWidth: "300px",
            maxWidth: "90vw",
            backgroundColor: "#b19bd5",
            color: "#fff",
          }}>
          ! <strong>تنبيه : </strong> عند وجود قيمه سالبه تعني ان هذا العميل
          لديه اموال
        </div>
      </div>
    </div>
  );
}

export default Customers;
